import {
  FETCH_USER_RECEIVED_MESSAGES_SUCCESS,
  FETCH_USER_SENT_MESSAGES_SUCCESS,
  FETCH_USER_MESSAGES_ASYNC_START,
  FETCH_USER_MESSAGES_ASYNC_END,
  FETCH_USER_BROADCASTS_ASYNC_START,
  FETCH_USER_BROADCASTS_ASYNC_END,
  FETCH_NEW_MESSAGES_SUCCESS,
  SET_SEEN_STATUS_REQUEST,
  FETCH_BROADCASTS_SUCCESS,
  SENT_MESSAGE_SUCCESS,
  BROADCAST_MESSAGE_SUCCESS,
  FETCH_NEW_BROADCASTS_SUCCESS,
  FETCH_MANAGER_EMAILS_SUCCESS,
  FETCH_MANAGER_SMS_SUCCESS,
} from '../actions/actions'
import dotProp from 'dot-prop-immutable-chain'

export default function messages(state = {}, action) {
  switch (action.type) {
    case FETCH_USER_MESSAGES_ASYNC_START:
    case FETCH_USER_BROADCASTS_ASYNC_START:
      return dotProp(state)
        .set(`aSyncCall`, true)
        .value()

    case FETCH_USER_MESSAGES_ASYNC_END:
    case FETCH_USER_BROADCASTS_ASYNC_END:
      return dotProp(state)
        .set(`aSyncCall`, false)
        .value()

    case FETCH_USER_RECEIVED_MESSAGES_SUCCESS:
      const { messages: receivedMessages, count: receivedCount } = action
      return dotProp(state)
        .set(`received`, {
          ...receivedMessages,
          isEverSynced: true,
          count: receivedCount,
        })
        .value()

    case FETCH_USER_SENT_MESSAGES_SUCCESS:
      const { messages: sentMessages, count: sentCount } = action
      return dotProp(state)
        .set(`sent`, { ...sentMessages, isEverSynced: true, count: sentCount })
        .value()

    case FETCH_NEW_MESSAGES_SUCCESS:
      const { newMessages } = action
      return dotProp(state)
        .set(`notification`, newMessages)
        .value()

    case FETCH_BROADCASTS_SUCCESS:
      const { broadcasts: broadcastedMessage } = action
      return dotProp(state)
        .set(`broadcasts`, {
          ...broadcastedMessage,
          isEverSynced: true,
          count: action.count,
        })
        .value()

    case SENT_MESSAGE_SUCCESS:
      const { message: sentMessage } = action
      return dotProp(state)
        .set(`sent.entities.messages.${sentMessage.id}`, sentMessage)
        .set(`sent.result`, result => [...result, sentMessage.id])
        .value()

    case BROADCAST_MESSAGE_SUCCESS:
      const { broadcast } = action
      return dotProp(state)
        .set(`broadcasted.entities.broadcasts${broadcast.id}`, broadcast)
        .set(`broadcasted.result`, result => [...result, broadcast.id])
        .value()

    case FETCH_NEW_BROADCASTS_SUCCESS:
      const { broadcasts: newBroadcasts } = action
      return dotProp(state)
        .set(`newBroadcasts`, newBroadcasts)
        .value()

    case FETCH_MANAGER_EMAILS_SUCCESS:
      const { emails, count: emailCount } = action
      return dotProp(state)
        .set(`emails`, { ...emails, count: emailCount })
        .value()

    case FETCH_MANAGER_SMS_SUCCESS:
      const { smsMessages, count: smsCount } = action
      return dotProp(state)
        .set(`smsMessages`, { ...smsMessages, count: smsCount })
        .value()

    case SET_SEEN_STATUS_REQUEST:
      const { messageType, messageId } = action
      // note that this acts upon request and is optimistic,
      // it does not wait for the server response
      switch (messageType) {
        case 'received':
          const receivedFilterer = result =>
            result.filter(id => id !== parseInt(messageId, 10))

          return (
            dotProp(state)
              //notifications for users are held in a independent part of store, so delete them
              .delete(`notification.entities.messages.${messageId}`)
              .set(`notification.result`, receivedFilterer)
              .value()
          )

        case 'broadcast':
          const broadcastFilterer = result =>
            result.filter(id => id !== parseInt(messageId, 10))

          return (
            dotProp(state)
              //notifications for users are held in a independent part of store, so delete them
              .delete(`newBroadcasts.entities.broadcasts.${messageId}`)
              .set(`newBroadcasts.result`, broadcastFilterer)
              .value()
          )

        default:
          return state
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/messages.js